export default ({ app }, inject) => {
  const currencyUnit = () => {
    return app.i18n.locale === "en" ? "USD" : "VNĐ";
  };

  inject("currencyUnit", currencyUnit); // $currencyUnit
};
